import { render, staticRenderFns } from "./InternalDepartmentManage.vue?vue&type=template&id=999ae35c&"
import script from "./InternalDepartmentManage.vue?vue&type=script&lang=js&"
export * from "./InternalDepartmentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports